import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getListFromValues, hasChangedValues, getFormValue, changeItemsValue, nullDate } from 'tyan/public/utility'
import { concat } from 'lodash'


class SupplierMainInstrumentWrite extends React.Component {
    state = {}
    componentDidMount = () => {
        const { initValues基本信息 } = this.props
        this.setState({ initValues基本信息, changedValues基本信息: {} })
    }

    handlerSave = () => {
        const { changedValues基本信息, typesOfchangedValues基本信息 } = this.state
        const { onConfirm, onClose } = this.props
        onConfirm && onConfirm(changedValues基本信息, typesOfchangedValues基本信息, onClose)
    }

    handlerDelete = () => {
        const { onDelete, onClose } = this.props
        Tyan.pubForm.showConfirm('确定要删除？', () => {
            onDelete && onDelete()
            onClose && onClose()
        })
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    canSave = () => {
        return getFormValue(this, '基本信息', '名称')
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    fieldset基本信息 = () => {
        return [
            { _text: '名称<br>Name',name:'名称', minWidth: '95%', required: true },
            { _text: '产品型号<br>Brand and model',name:'品牌型号', minWidth: '95%' },
            { _text: '购买时间<br>Purchase time',name:'购买时间', minWidth: '95%' },
            { _text: '制造商<br>Manufacturer',name:'制造商', minWidth: '95%' },
            { _text: '数量<br>Quantity',name:'数量', minWidth: '95%' },
            { _text: '使用工序<Use the process>',name:'使用工序', minWidth: '95%' },
            { _text: '产能<br>Capacity',name:'产能', minWidth: '95%' },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, bReadOnly, readOnly } = this.props
        const { errorMessage, initValues基本信息, id, } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        if (errorMessage) return <Message text={errorMessage} />
        const canSave = this.canSave()
        const bChanged = this.bChanged()
        return <Body data={this} maxWidth="700"
            controls={
                (bReadOnly || readOnly) ?
                    [
                        { _button: bChanged && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                    ] : [
                        { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !(canSave && bChanged) },
                        { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete },
                        { _button: bChanged ? '取消' : '关闭', icon: 'close', handler: this.handlerClose },
                    ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: bReadOnly || readOnly },
                ]}
        />
    }
}

export default connect()(SupplierMainInstrumentWrite)